import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { Toggle } from './Toggle';
import { SmartInput } from './SmartInput';
import { ControlGroup } from './ControlGroup';
import { SETTING_INFO } from './settingInfo';

interface SpawnerSettingsSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const SpawnerSettingsSection: React.FC<SpawnerSettingsSectionProps> = ({ config, setConfig }) => {
  const isSpawner = config.mode === 'SPAWNER';
  const spawnerMsg = "This setting is specifically for SPAWNER mode.";

  return (
    <div className="w-full flex flex-col gap-3 p-4 rounded-3xl border bg-orange-500/5 border-orange-500/10 mb-4">
      <div className="flex flex-col gap-3">
        <ControlGroup 
          label="Wall Spawn" 
          settingKey="spawnOnWallCollision"
          disabled={!isSpawner}
          disabledMessage={spawnerMsg}
          darkMode={config.darkMode}
        >
          <div className="flex items-center justify-end border border-white/5 p-2 rounded-xl">
            <Toggle active={config.spawnOnWallCollision} onClick={() => setConfig(p => ({...p, spawnOnWallCollision: !p.spawnOnWallCollision}))} />
          </div>
        </ControlGroup>
        <ControlGroup 
          label="Ball Spawn" 
          settingKey="spawnOnBallCollision"
          disabled={!isSpawner}
          disabledMessage={spawnerMsg}
          darkMode={config.darkMode}
        >
          <div className="flex items-center justify-end border border-white/5 p-2 rounded-xl">
            <Toggle active={config.spawnOnBallCollision} onClick={() => setConfig(p => ({...p, spawnOnBallCollision: !p.spawnOnBallCollision}))} />
          </div>
        </ControlGroup>
      </div>
      <SmartInput 
        label="Initial Balls" 
        min={1} max={50} 
        value={config.initialBalls} 
        onChange={v => setConfig(p => ({...p, initialBalls: v}))} 
        darkMode={config.darkMode} 
        settingKey="initialBalls"
      />
      <SmartInput 
        label="Max Balls" 
        min={10} max={1000} 
        value={config.maxBalls} 
        onChange={v => setConfig(p => ({...p, maxBalls: v}))} 
        darkMode={config.darkMode} 
        settingKey="maxBalls"
        disabled={!isSpawner}
        disabledMessage={spawnerMsg}
      />
    </div>
  );
};
